import {
  AddressSchema,
  NewOrderDataSchema,
} from "@redotech/redo-model/draft-return/draft-return";
import * as z from "zod/v4";

export const calculateNewOrderValue = {
  name: "calculateNewOrderValue" as const,
  input: z.object({
    orderId: z.string(),
    discountCodes: z.array(z.string()),
    useAutomaticDiscounts: z.boolean(),
    address: AddressSchema.optional(),
    items: z.array(
      z.object({
        quantity: z.number(),
        variantId: z.string(),
        productId: z.string().optional(),
      }),
    ),
  }),
  output: z.object({ newOrderData: NewOrderDataSchema }),
};
